import React, { useState } from 'react'
import { Dropdown, Form } from 'react-bootstrap';
import { base_url, postHeader } from '../../../Helper/request';
import axios from 'axios';
import { pencil } from '../../../Assets/svg';

function Engravings({val,cartlistapi, session_id, userdata, 
    // engravingtext,fontFamily,setEngravingtext,setfontFamily
}) {

    const [isEditing, setIsEditing] = useState(""); // Edit mode state
    const [isEditingHas, setIsEditingHas] = useState(false); // Edit mode state
    const [fontFamily, setfontFamily] = useState(val?.engraving_font);
    const [engravingtext, setEngravingtext] = useState(val?.engraving_text);
    const handleSaveEngarving = (cart_id) => {
        const data ={
          user_id: userdata?.user_id ? userdata?.user_id : "",
          session_id,
          cart_id: cart_id,
          engraving_text: engravingtext,
          engraving_font: fontFamily,
          token: userdata?.token ? userdata?.token : ""
        }
        
        axios.post(base_url + '/product/updateEngravingOnCart', data, {
          headers: postHeader
        })
          .then(response => {
            if (response.data.status == 1) {
              cartlistapi()
            } 
          })
          .catch((error) => {
            console.log(error);
          });
      }
      // ------------------------**********************engraving edit start--*********
  const handleEditClick = (c_id) => {
    setIsEditing(c_id);
    setIsEditingHas(true)
  };
  // ------------------------**********************engraving edit end--*********
  return (
    <>
    { isEditing == val?.cart_id ?
       <Form.Group controlId="formBasicEmail" className='editModeEngr'>
                    <Form.Control
                      onChange={(e) =>
                        setEngravingtext(e.target.value)
                      }
                      value={engravingtext}
                      type="text"
                      className='mb-2'
                      maxLength={15}
                      placeholder="15 Character Limit"
                    />
                    <Dropdown className='designFontScript'>
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        {fontFamily}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setfontFamily("Times New Roman")} href="javascript:void(0)"><img src={require("../../../Assets/images/product_list/times_new.jpg")} alt="" /></Dropdown.Item>
                        <Dropdown.Item onClick={() => setfontFamily("Script MJ Bold")} href="javascript:void(0)"><img src={require("../../../Assets/images/product_list/script_mj.jpg")} alt="" /></Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <div className='d-flex justify-content-between'>
                      <button onClick={() => {handleSaveEngarving(val?.cart_id); setIsEditing("")}} className='greenBtn mt-2'>Update</button>
                      <button onClick={() =>  setIsEditing("")} className='greenBtn mt-2'>Cancel</button>
                    </div>
                  </Form.Group>
                  : 
                  <div className='d-flex flex-wrap engravingEdit'>
                  <h4 className='product-price ' > Engraving: {val?.engraving_text}   { isEditing !== val?.cart_id &&
                    <button onClick={() => handleEditClick(val?.cart_id)} className='noBtn'>{pencil}</button>
                 }
                 </h4>
                
                  </div>
                       }
                     
    </>
  )
}

export default Engravings
